// extracted by mini-css-extract-plugin
export default {"component_lc":"ToTopButton__component_lc--lc-Iv2T3","visible_lc":"ToTopButton__visible_lc--lc-JHXCB","icon_lc":"ToTopButton__icon_lc--lc-XWcSg"};